import { UnitedStates as r } from "./united-states.js";
import { Greenland as o } from "./greenland.js";
import { Canada as m } from "./canada.js";
import { Mexico as i } from "./mexico.js";
import { FalklandIslands as t } from "./falkland-islands.js";
import { Brazil as p } from "./brazil.js";
import { Vietnam as a } from "./vietnam.js";
import { Thailand as f } from "./thailand.js";
import { Taiwan as n } from "./taiwan.js";
import { SouthKorea as e } from "./south-korea.js";
import { Singapore as l } from "./singapore.js";
import { Philippines as d } from "./philippines.js";
import { NewZealand as s } from "./new-zealand.js";
import { Mauritius as u } from "./mauritius.js";
import { Malaysia as c } from "./malaysia.js";
import { Japan as g } from "./japan.js";
import { Indonesia as y } from "./indonesia.js";
import { India as S } from "./india.js";
import { HongKong as h } from "./hong-kong.js";
import { China as C } from "./china.js";
import { Cambodia as I } from "./cambodia.js";
import { Brunei as M } from "./brunei.js";
import { Australia as w } from "./australia.js";
import { VaticanCity as b } from "./vatican-city.js";
import { UnitedKingdom as k } from "./united-kingdom.js";
import { Switzerland as F } from "./switzerland.js";
import { Sweden as G } from "./sweden.js";
import { Spain as L } from "./spain.js";
import { Slovenia as v } from "./slovenia.js";
import { Slovakia as x } from "./slovakia.js";
import { SanMarino as z } from "./san-marino.js";
import { Norway as A } from "./norway.js";
import { Austria as B } from "./austria.js";
import { Romania as K } from "./romania.js";
import { Portugal as N } from "./portugal.js";
import { Poland as P } from "./poland.js";
import { Netherlands as T } from "./netherlands.js";
import { Monaco as E } from "./monaco.js";
import { Malta as H } from "./malta.js";
import { Luxembourg as R } from "./luxembourg.js";
import { Lithuania as U } from "./lithuania.js";
import { Liechtenstein as V } from "./liechtenstein.js";
import { Latvia as D } from "./latvia.js";
import { Italy as J } from "./italy.js";
import { IsleOfMan as O } from "./isle-of-man.js";
import { Iceland as Z } from "./iceland.js";
import { FaroeIslands as j } from "./faroe-islands.js";
import { Estonia as q } from "./estonia.js";
import { Finland as Q } from "./finland.js";
import { France as W } from "./france.js";
import { Germany as X } from "./germany.js";
import { Gibraltar as Y } from "./gibraltar.js";
import { Greece as _ } from "./greece.js";
import { Hungary as $ } from "./hungary.js";
import { CzechRepublic as rr } from "./czech-republic.js";
import { Denmark as or } from "./denmark.js";
import { Egypt as mr } from "./egypt.js";
import { Cyprus as ir } from "./cyprus.js";
import { Croatia as tr } from "./croatia.js";
import { Belgium as pr } from "./belgium.js";
import { Andorra as ar } from "./andorra.js";
import { Turkey as fr } from "./turkey.js";
const So = {
  UnitedStates: r,
  Greenland: o,
  Canada: m,
  Mexico: i,
  FalklandIslands: t,
  Brazil: p,
  Vietnam: a,
  Thailand: f,
  Taiwan: n,
  SouthKorea: e,
  Singapore: l,
  Philippines: d,
  NewZealand: s,
  Mauritius: u,
  Malaysia: c,
  Japan: g,
  Indonesia: y,
  India: S,
  HongKong: h,
  China: C,
  Cambodia: I,
  Brunei: M,
  Australia: w,
  VaticanCity: b,
  UnitedKingdom: k,
  Switzerland: F,
  Sweden: G,
  Spain: L,
  Slovenia: v,
  Slovakia: x,
  SanMarino: z,
  Norway: A,
  Austria: B,
  Romania: K,
  Portugal: N,
  Poland: P,
  Netherlands: T,
  Monaco: E,
  Malta: H,
  Luxembourg: R,
  Lithuania: U,
  Liechtenstein: V,
  Latvia: D,
  Italy: J,
  IsleOfMan: O,
  Iceland: Z,
  FaroeIslands: j,
  Estonia: q,
  Finland: Q,
  France: W,
  Germany: X,
  Gibraltar: Y,
  Greece: _,
  Hungary: $,
  CzechRepublic: rr,
  Denmark: or,
  Egypt: mr,
  Cyprus: ir,
  Croatia: tr,
  Belgium: pr,
  Andorra: ar,
  Turkey: fr
};
export {
  So as Countries
};
